import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Button from '../elements-buttons/Button';
import validateSpaceTag from './forms/validateSpaceTagForm';
import onSubmitTag from './forms/onSubmitTag';
import { get } from 'lodash';
import SpaceTypeTaggingField from './SpaceTypeTaggingField';
import ParkingFields from '../app-parking-info/ParkingFields';
import SurveillanceFields from '../app-surveillance-info/SurveillanceFields';
import parkingInitialValues from '../app-parking-info/data/getInitialValues';
import surveillanceInitialValues from '../app-surveillance-info/data/getInitialValues';
import { FormattedMessage } from 'react-intl';
import OvernightStaysField from '../add-a-space/OvernightStaysField';

const SpaceTypeTaggingForm = ({
  error,
  tags = [],
  handleSubmit,
  space = {},
  typeTagFieldValue = '',
  parkingToggleFieldValue,
  surveillanceToggleFieldValue
}) => {
  const redirectToAddressForm = () => {
    window.location.href = `/your-space/${space.data?._id}/address`;
  };

  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <div className="set-up-form-container">
        <SpaceTypeTaggingField tags={tags} space={space} typeTagFieldValue={typeTagFieldValue} />
        <hr className="tag-parking-fields-line-break"/>
        <div className="margin-xl-top">
          <OvernightStaysField />
        </div>
        <hr className="tag-parking-fields-line-break"/>
        <ParkingFields parkingToggleFieldValue={parkingToggleFieldValue} />
        <hr className="tag-parking-fields-line-break"/>
        <div className="margin-xl-top">
          <SurveillanceFields surveillanceToggleFieldValue={surveillanceToggleFieldValue} />
        </div>
        <hr className="margin-xxl-top space-type-line-break"/>
        <div className="flex space-between">
          <Button
            category="default"
            type="button"
            className="margin-md-right btn-outlined-light"
            onClick={redirectToAddressForm}
          >
            <FormattedMessage
              id="hosting.space_type_tagging_form.button_text_back"
              defaultMessage="Back"
            />
          </Button>
          <Button
            category="primary"
            className="submit-cta"
            disabled={false}
            attributes={{
              'data-testing-id': 'setup-cta'
            }}
          >
            <FormattedMessage
              id="hosting.space_type_tagging_form.button_text_next"
              defaultMessage="Next"
            />
          </Button>
        </div>
      </div>
      <div className="text-danger text-small">{error}</div>
    </form>
  );
};

SpaceTypeTaggingForm.propTypes = {
  handleSubmit: PropTypes.func,
  tags: PropTypes.array,
  error: PropTypes.string,
  space: PropTypes.object,
  typeTagFieldValue: PropTypes.string,
  parkingToggleFieldValue: PropTypes.string,
  surveillanceToggleFieldValue: PropTypes.string
};

const config = {
  form: 'SPACE_TYPE_TAGGING',
  validate: validateSpaceTag,
  onSubmit: onSubmitTag
};

const selector = formValueSelector('SPACE_TYPE_TAGGING');

function mapStateToProps (state) {
  const spaceTypeTag = PSSessions.Cookies('aas_type');
  const typeTagFieldValue = selector(state, 'type_tag');
  const parkingToggleFieldValue = selector(state, 'is_available');
  const surveillanceToggleFieldValue = selector(state, 'has_surveillance');
  const type_tag = get(state, 'space.data.initial_host_submitted_type_tag', '') ||
    spaceTypeTag;
  const overnightStays = get(state, 'space.data.overnight_stays', '');

  return {
    typeTagFieldValue,
    parkingToggleFieldValue,
    surveillanceToggleFieldValue,
    initialValues: {
      type_tag,
      overnight_stays: String(overnightStays),
      ...parkingInitialValues(state),
      ...surveillanceInitialValues(state)
    }
  };
}

export default connect(mapStateToProps)(reduxForm(config)(SpaceTypeTaggingForm));
